import { create } from 'zustand'

type Theme = 'light' | 'dark' | 'system'
const KEY = 'sfc.theme'

function apply(t: Theme) {
  const root = document.documentElement
  if (t === 'system') root.removeAttribute('data-theme')
  else root.setAttribute('data-theme', t)
}

const initial: Theme = (() => {
  try {
    return (localStorage.getItem(KEY) as Theme | null) ?? 'system'
  } catch {
    return 'system'
  }
})()
apply(initial)

export const useTheme = create<{ theme: Theme; toggle: () => void }>((set, get) => ({
  theme: initial,
  toggle: () => {
    const current = get().theme
    const isDark =
      current === 'system'
        ? window.matchMedia('(prefers-color-scheme: dark)').matches
        : current === 'dark'
    const next: Theme = isDark ? 'light' : 'dark'
    apply(next)
    try {
      localStorage.setItem(KEY, next)
    } catch {
      /* ignore */
    }
    set({ theme: next })
  },
}))
